import { ErrorResponse, GlobalStatus } from '@gtpl/shared-models/common-models';
import { PlantInvoiceCreateResponse } from '@gtpl/shared-models/logistics';
import { Injectable } from '@nestjs/common';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PlantInvoiceAdapter } from './adapters/plant-invoice.adapter';
import { SoCustomerInvoice } from './customer-invoice.entity';
import { PlantInvoiceDto } from './dto/plant-invoice.dto';
import { CustomerInvoiceRepository } from './repository/customer-invoice-repository';
import { SoInvoiceRepository } from './repository/so-inv-details-repository';
import { SoItemRepository } from './repository/so-items-repository';
import { SoRepository } from './repository/so-repository';
import { SaleOrderItems } from './sale-order-items.entity';


@Injectable()
export class CustomerInvoiceService {
    constructor(private csInvoiceRepo:CustomerInvoiceRepository, private soInvItemRepo:SoItemRepository,private adapter:PlantInvoiceAdapter, private soRepo:SoRepository){}

    async createPlantInvoice(invoiceDto: PlantInvoiceDto, isUpdate:boolean):Promise<PlantInvoiceCreateResponse>{
        console.log("Invoice Service")
        const manager = new GenericTransactionManager();
        try{
            let today =new Date();
            let CurrentYear = today.getFullYear();
            let CurrentMonth = today.getMonth();
            let fromDate=0;
            let toDate=0;
            let count;
            count = await this.csInvoiceRepo.count();
            count = count + 1;
            if(!isUpdate){
                if (CurrentMonth<4) {
                    fromDate=(CurrentYear);
                    toDate=(CurrentYear+1);
                } else {
                    fromDate=(CurrentYear);
                    toDate=(CurrentYear+1);
                }
                const customerInvEntity = await this.getDuplicateInvoice(invoiceDto.saleOrderId);
                if (customerInvEntity) {
                    return new PlantInvoiceCreateResponse(false,11104, 'Already Invoiced');
                  }
            }
         
            const currentFinancialYear = "INV/"+(fromDate)+"-"+(toDate)+"/"+count;
            console.log(invoiceDto);
            console.log('Service');
            // convert entity to dto
            const convertedEntity = await this.adapter.convertDtoToEntity(invoiceDto, currentFinancialYear);
            console.log(convertedEntity);
            await manager.startTransaction();

            // save the converted Entity
            const savedEntity = await manager.getCustomRepository(CustomerInvoiceRepository).save(convertedEntity);
            if(savedEntity){
                    for(const invoiceItems of invoiceDto.invoiceItemsInfo){
                        const csInvItem = new SaleOrderItems();
                        csInvItem.saleOrderItemId = invoiceItems.saleOrderItemId;
                        csInvItem.revisedUnitPrice = invoiceItems.revisedUnitPrice;
                        csInvItem.invoicedQty = invoiceItems.invoicedQuantity;
                        csInvItem.invoicedCases = invoiceItems.invoicedCases;
                        csInvItem.invoiceAmount = invoiceItems.invoiceAmount;
                        csInvItem.grossWeightPerKg = invoiceItems.grossWeight;
                        //for temperory dispatched qty given.need to remove after completion of warehouse as dispatched qty updated from warehouse
                        //csInvItem.dispatchedQty = invoiceItems.dispatchedQty;
                        csInvItem.totalGrossWeight = invoiceItems.grossWeight * invoiceItems.invoicedCases
                        console.log('*******revisedUnitPrice ',csInvItem.revisedUnitPrice)
                        csInvItem.taxId = invoiceItems.taxId;
                        const updateInvItem = await manager.getCustomRepository(SoItemRepository).save(csInvItem);
                    }
                    const updateSo = await manager.getCustomRepository(SoRepository).update({saleOrderId:invoiceDto.saleOrderId},{
                        isInvoiced:GlobalStatus.YES
                    });
                    const updateInvDetails = await manager.getCustomRepository(SoInvoiceRepository).update({saleOrderId:invoiceDto.saleOrderId},{
                        payTermId:invoiceDto.paymentTerms,destination:invoiceDto.finalDestination,portOfEntry:invoiceDto.portOfLoading,edaDate:invoiceDto.etaDate
                    });

                    if(updateSo.affected&&updateInvDetails.affected&&!isUpdate){
                        await manager.completeTransaction();
                    }else{
                        if(isUpdate){
                            await manager.completeTransaction();
                        }else{
                            throw new ErrorResponse(9999, 'Failed To Update Sale Order');
                        }
                    }
                    return new PlantInvoiceCreateResponse(true, 1111, 'Invoice Created Successfully');
            }else{
                throw new ErrorResponse(9999, 'Something Went Wrong');
            }

        }catch(err){
            await manager.releaseTransaction();
            console.log(err);
            return err;
        }
    }

    async getDuplicateInvoice(saleOrderId: number): Promise<SoCustomerInvoice> {
        //  console.log(employeeId);
            const response = await this.csInvoiceRepo.findOne({
            where: {saleOrderId: saleOrderId},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }
    
}
